import DesTeamListViewModel from 'viewmodel/DesTeamListViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesTeamList extends DesBaseCatalogAcc {
    constructor() {
        super(DesTeamListViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'collaborationspaceid', 'locale'];
    }
}

if (!window.customElements.get('des-team-list')) {
    window.customElements.define('des-team-list', DesTeamList);
}
